import React from "react";
import { useNavigate } from "react-router-dom";
import ProductGrid from "./ProductGrid";
import reportImage from "../assets/images/Report.png";
import styles from "../styles/ServiceSection.module.css";

const NumerologyServices = ({ variant = "cards" }) => {
  const navigate = useNavigate();

  return (
    <section className={styles.serviceSection} id="numerology-section">
      <ProductGrid
        serviceId={10}
        title="Numerology Services"
        defaultPageSize={20}
        showPagination={true}
        defaultImage={reportImage}
        useProductImages={true}  // Product's main image; default image if it has none
        variant={variant}
        viewAllLink={variant === "carousel" ? "/numerology-services" : null}
        // Numerology products land on /numerology/:sku (CustomFieldRenderer-driven form), not
        // /landing/:sku (ProductGrid's astrology-only default) — see NumerologyLandingPage.jsx.
        onProductClick={(product) => navigate(`/numerology/${product.sku}`)}
      />
    </section>
  );
};

export default NumerologyServices;
